import "./VenueAndPartyInfoCard.css";
import { Link } from "react-router-dom";
import { CiLocationOn } from "react-icons/ci";
import { FaDirections } from "react-icons/fa";
import { BsCalendar2Date } from "react-icons/bs";
import { IoTimeOutline, IoRestaurantSharp } from "react-icons/io5";
import { BiDrink } from "react-icons/bi";
import { API_BASE_URL, openInGoogleMaps } from "../../utils";
import NoEvent from "../../My--Bidding--design/image/no-event.svg";
import { HiOutlineLocationMarker } from "react-icons/hi";
import ClubProfileSection from "../../My--Bidding--design/comp/ClubProfileSection";
import PackageTitleName from "../../My--Bidding--design/comp/PackageTitleName";
import ServiceTimeOfClub from "../../My--Bidding--design/comp/ServiceTimeOfClub";
import PartyDateAndTime from "./PartyDateAndTime";

const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};
const url = `${API_BASE_URL}/master/assets/uploads/`;

const VenueAndPartyInfoCard = ({ data }) => {
  return (
    <>
      <div className="pmu-card-content-left">
        {/* Photos */}
        <div className="d-flex gap-2">
          <div className="pmu-photos">
            <img
              src={url + data?.club_gallery?.[0]?.img}
              alt="venue"
              onError={(e) => {
                e.target.src =
                  "https://img.freepik.com/free-vector/party-neon-sign_540545-36.jpg?semt=ais_hybrid&w=740&q=80";
              }}
            />
            <span className="pmu-photos-count">
              {data?.club_gallery?.length
                ? `${data?.club_gallery.length}+ Photos`
                : "-- Photos"}
            </span>
          </div>

          <div className="pmu-card-content-right d-hide">
            <div className="pmu-events">
              {data?.events && data.events.length ? (
                <Link
                  to={`/event/${data?.events[0]?.slug1}/${data?.events[0]?.slug2}`}>
                  <img src={url + data?.events[0]?.image} alt="event" />
                  <div className="pmu-event-info">
                    <h6>{data?.events[0]?.name}</h6>
                    <span>
                      Time: {data?.events[0]?.event_time} -{" "}
                      {data?.events[0]?.event_end_time}
                    </span>
                  </div>
                </Link>
              ) : (
                <>
                  <img src={NoEvent} alt={`venue ${1}`} />
                </>
              )}
            </div>
          </div>
        </div>

        {/* Venue Info */}
        <div className="pmu-venue-info">
          <ClubProfileSection
            clublogo={
              data?.clubLogo ? url + data.clubLogo : url + data?.profile_pic
            }
            address={data?.club_address}
            distance={data?.distance}
            name={data?.club_name}
          />

          <PackageTitleName title={data?.package_title_name || "--"} />

          {/* <div className="pmu-venue-meta-date-time">
                        <span className="pmu-meta-chip">
                            <span>
                                <BsCalendar2Date /> Date
                            </span>
                            {formatDate(data?.party_date)},
                        </span>
                        <span className="pmu-meta-chip">
                            <span>
                                <IoTimeOutline /> Time
                            </span>
                            {data?.party_time} Onwards
                        </span>
                    </div> */}

          <PartyDateAndTime date={data?.party_date} time={data?.party_time} />

          <ServiceTimeOfClub
            foodserving={data?.foodserving}
            alcoholserving={data?.alcoholserving}
          />
        </div>
      </div>

      {/* Events */}
      <div className="pmu-card-content-right m-hide">
        <div className="pmu-events">
          {data?.events && data.events.length ? (
            <Link
              to={`/event/${data?.events[0]?.slug1}/${data?.events[0]?.slug2}`}>
              <img src={url + data?.events[0]?.image} alt="event" />
              <div className="pmu-event-info">
                <h6>{data?.events[0]?.name}</h6>
                <span>
                  Time: {data?.events[0]?.event_time} -{" "}
                  {data?.events[0]?.event_end_time}
                </span>
              </div>
            </Link>
          ) : (
            <>
              <img src={NoEvent} alt={`venue ${1}`} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default VenueAndPartyInfoCard;
